<template>
  <div class="flex-1 overflow-auto campaigns-scroll-root">
    <campaigns-table
      :campaigns="campaigns"
      :total-count="campaignsListTotalCount"
      :current-page="campaignsListPage"
      :page-size="campaignsPerPage"
      :show-empty-result="showEmptyResult"
      :is-loading="uiFlags.isFetching"
      :campaign-type="type"
      @edit="openEditPopup"
      @delete="openDeletePopup"
      @page-change="onPageChange"
    />
    <woot-modal :show.sync="showEditPopup" :on-close="hideEditPopup">
      <edit-campaign
        :selected-campaign="selectedCampaign"
        @on-close="hideEditPopup"
      />
    </woot-modal>
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('CAMPAIGN.DELETE.CONFIRM.TITLE')"
      :message="$t('CAMPAIGN.DELETE.CONFIRM.MESSAGE')"
      :confirm-text="$t('CAMPAIGN.DELETE.CONFIRM.YES')"
      :reject-text="$t('CAMPAIGN.DELETE.CONFIRM.NO')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import campaignMixin from 'shared/mixins/campaignMixin';
import CampaignsTable from './CampaignsTable';
import EditCampaign from './EditCampaign';
export default {
  components: {
    CampaignsTable,
    EditCampaign,
  },
  mixins: [alertMixin, campaignMixin],
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEditPopup: false,
      selectedCampaign: {},
      showDeleteConfirmationPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'campaigns/getUIFlags',
      labelList: 'labels/getLabels',
      campaignsListTotalCount: 'campaigns/getCampaignsListTotalCount',
      campaignsListPage: 'campaigns/getCampaignsListPage',
    }),
    campaigns() {
      return this.$store.getters['campaigns/getCampaigns'](this.campaignType);
    },
    campaignsPerPage() {
      return 20;
    },
    showEmptyResult() {
      const hasEmptyResults =
        !this.uiFlags.isFetching && this.campaigns.length === 0;
      return hasEmptyResults;
    },
  },
  mounted() {
    this.fetchCampaignsForCurrentType();
  },
  watch: {
    campaignType(newType, oldType) {
      if (newType && newType !== oldType) {
        this.fetchCampaignsForCurrentType();
      }
    },
  },
  methods: {
    fetchCampaignsForCurrentType(page = 1) {
      if (!this.campaignType) return;
      this.$store.dispatch('campaigns/getPaginated', {
        campaignType: this.campaignType,
        page,
        perPage: this.campaignsPerPage,
      });
    },
    onPageChange(page) {
      this.fetchCampaignsForCurrentType(page);
    },
    openEditPopup(campaign) {
      this.selectedCampaign = campaign;
      this.showEditPopup = true;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    openDeletePopup(campaign) {
      this.showDeleteConfirmationPopup = true;
      this.selectedCampaign = campaign;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    confirmDeletion() {
      this.closeDeletePopup();
      const { id, display_id } = this.selectedCampaign;
      this.deleteCampaign(id, display_id);
    },
    async deleteCampaign(id, displayId) {
      try {
        await this.$store.dispatch('campaigns/delete', { id, displayId });
        this.showAlert(this.$t('CAMPAIGN.DELETE.API.SUCCESS_MESSAGE'));
        const perPage = this.campaignsPerPage;
        const newTotal = Math.max(0, this.campaignsListTotalCount - 1);
        const maxPage = Math.max(1, Math.ceil(newTotal / perPage));
        const targetPage = Math.min(this.campaignsListPage, maxPage);
        this.fetchCampaignsForCurrentType(targetPage);
      } catch (error) {
        this.showAlert(this.$t('CAMPAIGN.DELETE.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* Allow this flex child to be the scroll container so sticky pagination works */
.campaigns-scroll-root {
  height: calc(100vh - 7.5rem);
}

.button-wrapper {
  @apply flex justify-end pb-2.5;
}
</style>
